import APIS from '../apiUrl';
import axios from 'axios';
import { requireAuthHeaders } from '../auth/getAuthToken';

export interface Permission {
  type: 'org';
  principal: string;
  permissions: {
    readTubes?: boolean;
    readPressures?: boolean;
    readPies?: boolean;
    readIdleVsPressure?: boolean;
    readConfiguration?: boolean;
  };
}

export async function share(id: string, permissions: Permission[]): Promise<void> {
  await axios.post(`${APIS.SENTINEL_API}/api/logs/${id}/share`, permissions, {
    headers: await requireAuthHeaders(),
  });
}

export const downloadLogFile = async (logId: string, logName: string) => {
  try {
    const signedRequest = await getSignedRequest(logId);

    // Puts the fileType in the headers for the upload.
    const options: any = {
      responseType: 'blob',
      ContentType: 'application/octet-stream',
    };
    const docResponse = await axios.get(signedRequest, options);

    const url = window.URL.createObjectURL(new Blob([docResponse.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', logName); // or any other extension
    document.body.appendChild(link);
    link.click();
  } catch (err) {
    console.error('Unknown failure in log helper:', err);
  }
};

const getSignedRequest = async (logId: string) => {
  const response = await axios({
    method: 'POST',
    url: `${APIS.SENTINEL_API}/api/logs/getsigned`,

    headers: await requireAuthHeaders(),
    data: {
      logId: logId,
      s3: {
        actionType: 'getObject',
      },
    },
  });

  const returnData = response.data.data;
  const { signedRequest } = returnData;

  return signedRequest;
};

interface LiveSyncDataReplaceLinesArray {
  strategy: 'replace-lines';
  lines: string[];
}

type LiveSyncData = LiveSyncDataReplaceLinesArray;

export interface LiveSyncRequest {
  id: string;
  data: LiveSyncData;
}

export const logsApiLiveSync = async (body: LiveSyncRequest) => {
  await axios({
    method: 'POST',
    url: `${APIS.SENTINEL_API}/api/logs/live/v2/${body.id}/sync`,
    data: body.data,
    headers: await requireAuthHeaders(),
  });
};
